import React, { useEffect, useState } from "react";
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  Skeleton,
  Snackbar,
  Tab,
  Tabs,
  Tooltip,
  Typography,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import ApartmentIcon from "@mui/icons-material/Apartment";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import ChevronLeftOutlinedIcon from "@mui/icons-material/ChevronLeftOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import CallOutlinedIcon from "@mui/icons-material/CallOutlined";
import axios from "axios";
import Cookies from "js-cookie";
import { useSelector } from "react-redux";
import DeleteJobDialog from "./DeleteJobDialog";
import AddBranch from "../components/addBranch";

const BranchDetails = () => {
  const navigate = useNavigate();
  const { id, branchId } = useParams();

  const [branchInfo, setBranchInfo] = useState({});
  const [companyLogo, setCompanyLogo] = useState("");
  const [backbutton, setBackbutton] = useState(false);
  const [selectedTab, setSelectedTab] = useState("BranchInfo");
  const [pageLoading, setPageLoading] = useState(true);

  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [Snackbarserverity, setSnackbarServerity] = useState();
  const [editBranchOpen, setEditBranchOpen] = useState(false);

  const managePermissions = useSelector((state) => state?.user.permissions);
  const editBranchPermission = managePermissions["500"];

  const getCompanyDetails = async () => {
    try {
      const response = await axios.get(`/company-info/${id}`, {
        headers: {
          authorization:
            Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref"),
        },
      });
      setCompanyLogo(response.data.message[0]?.logo || "");
    } catch {}
  };

  const getBranchInfo = async () => {
    try {
      const res = await axios.get(`/branch-info/${branchId}`, {
        headers: {
          authorization:
            Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref"),
        },
      });
      setBranchInfo(res.data.message[0] || {});
    } catch {}
  };

  useEffect(() => {
    const fetchAll = async () => {
      setPageLoading(true);
      await Promise.all([getCompanyDetails(), getBranchInfo()]);
      setPageLoading(false);
    };
    fetchAll();
  }, [id, branchId]);

  const handleBack = () => {
    const previousUrl = sessionStorage.getItem("BranchpreviousUrl");
    if (previousUrl) {
      const url = new URL(previousUrl, window.location.origin);
      navigate(`${url.pathname}${url.search}`);
      sessionStorage.removeItem("BranchpreviousUrl");
    } else {
      navigate(`/CompanyDetails/${id}?tab=companyBranch&page=1`);
    }
  };

  const handleBranchUpdated = async () => {
    setPageLoading(true);
    await Promise.all([getCompanyDetails(), getBranchInfo()]);
    setPageLoading(false);
  };

  const canEdit =
    editBranchPermission?.edit === 1 && branchInfo?.is_editable === 1;
  const canDelete =
    editBranchPermission?.delete === 1 && branchInfo?.is_editable === 1;

  const basicDetailsMap = {
    Name: branchInfo?.name || "NA",
    State: branchInfo?.state || "NA",
    City: branchInfo?.city || "NA",
    "Contact Number": branchInfo?.phone1 || "NA",
    Address: branchInfo?.address || "NA",
    "Website Link": branchInfo?.website || "NA",
    "Created On": branchInfo?.date_created
      ? new Date(branchInfo.date_created).toLocaleDateString("en-GB")
      : "NA",
  };

  return (
    <Box
      sx={{
        backgroundColor: "#E3F2FD",
        height: "100%",
        borderRadius: "24px 0 0 0",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#FFF",
          padding: "16px",
          borderRadius: "12px",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "16px",
        }}
      >
        {/* ── Back + Title ── */}
        <Box
          sx={{
            display: "flex",
            borderBottom: "1px solid rgba(21, 29, 72, 0.12)",
            paddingBottom: "16px",
            gap: "12px",
            alignItems: "center",
          }}
        >
          <Button
            startIcon={
              <ChevronLeftOutlinedIcon
                style={{ height: "16px", width: "16px" }}
              />
            }
            sx={{
              "& .MuiButton-startIcon": backbutton
                ? { marginRight: "4px !important" }
                : { margin: "0px" },
            }}
            style={
              backbutton
                ? {
                    backgroundColor: "#3F95EA",
                    color: "white",
                    height: "24px",
                    fontSize: "12px",
                    textTransform: "none",
                  }
                : {
                    backgroundColor: "#E7E7E7",
                    color: "#1A1A1A",
                    minWidth: "24px",
                    height: "24px",
                    padding: "4px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }
            }
            onMouseEnter={() => setBackbutton(true)}
            onMouseLeave={() => setBackbutton(false)}
            onClick={handleBack}
          >
            {backbutton ? "Back" : ""}
          </Button>
          <Typography sx={{ fontSize: "22px", fontWeight: 600 }}>
            Branch Details
          </Typography>
        </Box>

        {/* ── Logo + Name + Actions ── */}
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Box sx={{ display: "flex", gap: "16px", alignItems: "center" }}>
            {/* Logo */}
            <Box
              sx={{
                width: "100px",
                height: "100px",
                backgroundColor: "#E3F2FD",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
              }}
            >
              {pageLoading ? (
                <Skeleton
                  variant="rectangular"
                  width={100}
                  height={100}
                  sx={{ borderRadius: "8px" }}
                />
              ) : companyLogo ? (
                <img
                  src={companyLogo}
                  alt="Company Logo"
                  style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "contain",
                    borderRadius: "8px",
                  }}
                />
              ) : (
                <ApartmentIcon sx={{ fontSize: "100px", color: "#979797" }} />
              )}
            </Box>

            {/* Name + badges */}
            <Box>
              {pageLoading ? (
                <>
                  <Skeleton
                    variant="text"
                    width={160}
                    height={32}
                    sx={{ mb: 0.5 }}
                  />
                  <Skeleton
                    variant="rounded"
                    width={200}
                    height={24}
                    sx={{ borderRadius: "20px" }}
                  />
                </>
              ) : (
                <>
                  <Box
                    sx={{
                      display: "flex",
                      gap: "8px",
                      alignItems: "center",
                      mb: "4px",
                    }}
                  >
                    <Typography
                      fontSize="20px"
                      fontWeight={600}
                      sx={{ textTransform: "capitalize" }}
                    >
                      {branchInfo?.name || "NA"}
                    </Typography>
                    {branchInfo?.is_default === 1 && (
                      <Typography
                        sx={{
                          fontSize: "12px",
                          fontWeight: "500",
                          padding: "0.25rem 0.5rem",
                          border: "1px solid #99C4E2",
                          borderRadius: "0.25rem",
                          color: "#006CB7",
                        }}
                      >
                        Default
                      </Typography>
                    )}
                  </Box>
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                    {[
                      branchInfo?.city && branchInfo?.state
                        ? {
                            icon: (
                              <LocationOnOutlinedIcon
                                sx={{ fontSize: "13px" }}
                              />
                            ),
                            label: `${branchInfo.city}, ${branchInfo.state}`,
                          }
                        : null,
                      branchInfo?.phone1
                        ? {
                            icon: (
                              <CallOutlinedIcon sx={{ fontSize: "13px" }} />
                            ),
                            label: branchInfo.phone1,
                          }
                        : null,
                    ]
                      .filter(Boolean)
                      .map((badge, i) => (
                        <Box
                          key={i}
                          sx={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "4px",
                            px: "10px",
                            py: "3px",
                            borderRadius: "20px",
                            backgroundColor: "#F1F5F9",
                            color: "#475569",
                            fontSize: "12px",
                            fontWeight: 500,
                          }}
                        >
                          {badge.icon}
                          {badge.label}
                        </Box>
                      ))}
                  </Box>
                </>
              )}
            </Box>
          </Box>

          {/* ── Action Buttons ── */}
          {pageLoading ? (
            <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <Skeleton
                variant="rounded"
                width={80}
                height={34}
                sx={{ borderRadius: "8px" }}
              />
              <Skeleton
                variant="rounded"
                width={34}
                height={34}
                sx={{ borderRadius: "8px" }}
              />
            </Box>
          ) : (
            canEdit && (
              <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                {/* Edit — blue outlined */}
                <Button
                  variant="outlined"
                  startIcon={<img src="/assets/edit.svg" alt="" />}
                  onClick={() => setEditBranchOpen(true)}
                  sx={{
                    textTransform: "none",
                    fontWeight: 500,
                    fontSize: "14px",
                    borderRadius: "8px",
                    borderColor: "#3F95EA",
                    color: "#3F95EA",
                    height: "34px",
                    px: 2,
                    "&:hover": {
                      borderColor: "#2e82d8",
                      backgroundColor: "rgba(63,149,234,0.06)",
                    },
                  }}
                >
                  Edit
                </Button>

                {/* Delete — red outlined icon only */}
                {canDelete && (
                  <>
                    <Tooltip
                      title={
                        branchInfo.is_internal === 1
                          ? "Internal branch can't be deleted"
                          : ""
                      }
                      disableHoverListener={branchInfo.is_internal !== 1}
                    >
                      <span>
                        <Button
                          variant="outlined"
                          disabled={branchInfo.is_internal === 1}
                          onClick={() => setOpenDeleteDialog(true)}
                          sx={{
                            minWidth: "36px",
                            width: "34px",
                            height: "34px",
                            p: 0,
                            borderRadius: "8px",
                            borderColor: "#EF4444",
                            color: "#EF4444",
                            "&:hover": {
                              borderColor: "#dc2626",
                              backgroundColor: "rgba(239,68,68,0.06)",
                            },
                            "&.Mui-disabled": {
                              borderColor: "#fca5a5",
                              color: "#fca5a5",
                            },
                          }}
                        >
                          <img src="/assets/delete.svg" alt="" />
                        </Button>
                      </span>
                    </Tooltip>
                    <DeleteJobDialog
                      Deletename={branchInfo.name}
                      id={branchId}
                      open={openDeleteDialog}
                      handleClose={() => setOpenDeleteDialog(false)}
                      setOpenSnackbar={setOpenSnackbar}
                      setSnackbarMessage={setSnackbarMessage}
                      setSnackbarServerity={setSnackbarServerity}
                    />
                  </>
                )}
              </Box>
            )
          )}
        </Box>
        <Tabs
          value={selectedTab}
          onChange={(e, newValue) => setSelectedTab(newValue)}
          sx={{ borderBottom: "1px solid rgba(0, 0, 0, 0.12)" }}
        >
          <Tab
            value="BranchInfo"
            label="Branch Info"
            sx={{ fontWeight: "500", fontSize: "14px", textTransform: "none" }}
          />
        </Tabs>

        {/* ── Tab Content ── */}
        {selectedTab === "BranchInfo" && (
          <Box
            sx={{
              display: "flex",
              width: "100%",
              gap: "20px",
              height: "calc(100% - 250px)",
            }}
          >
            <Card
              elevation={0}
              sx={{
                borderRadius: "4px",
                border: "1px solid rgba(115, 119, 145, 0.08)",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                maxHeight: "100%",
                overflow: "hidden",
              }}
            >
              <Box
                sx={{
                  borderRadius: "4px 4px 0 0",
                  padding: "14px 20px",
                  backgroundColor: "rgba(63, 149, 234, 0.20)",
                  fontSize: "14px",
                  fontWeight: "600",
                  flexShrink: 0,
                }}
              >
                Basic Details
              </Box>
              <CardContent
                sx={{ padding: "16px 20px", flexGrow: 1, overflowY: "auto" }}
              >
                {pageLoading
                  ? Array.from({ length: 7 }).map((_, i) => (
                      <Box
                        key={i}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          mb: "12px",
                          gap: 2,
                        }}
                      >
                        <Skeleton variant="text" width={130} height={20} />
                        <Skeleton
                          variant="text"
                          width={`${[60, 80, 100, 70, 90, 65, 75][i]}px`}
                          height={20}
                        />
                      </Box>
                    ))
                  : Object.entries(basicDetailsMap).map(([key, value]) => (
                      <Box
                        key={key}
                        sx={{
                          display: "flex",
                          alignItems: "flex-start",
                          flexWrap: "wrap",
                          marginBottom: "8px",
                        }}
                      >
                        <Typography
                          sx={{
                            fontWeight: "400",
                            fontSize: "14px",
                            color: "rgba(0, 0, 0, 0.60)",
                            minWidth: "160px",
                            maxWidth: "160px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {key}
                        </Typography>
                        <Typography
                          sx={{
                            fontWeight: "400",
                            fontSize: "14px",
                            color: "rgba(0, 0, 0, 0.87)",
                            flex: 1,
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                          }}
                        >
                          {value}
                        </Typography>
                      </Box>
                    ))}
              </CardContent>
            </Card>
          </Box>
        )}
      </Box>

      {editBranchOpen && (
        <AddBranch
          open={editBranchOpen}
          onClose={() => setEditBranchOpen(false)}
          onSuccess={handleBranchUpdated}
          companyId={id}
          editBranchId={branchId}
          editMode
          disableNavigation
        />
      )}

      {/* ── Snackbar ── */}
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={(e, reason) => {
          if (reason !== "clickaway") setOpenSnackbar(false);
        }}
      >
        <Alert
          severity={Snackbarserverity}
          sx={{ width: "100%" }}
          onClose={() => setOpenSnackbar(false)}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default BranchDetails;
